import {Observable, Subscription} from 'rxjs';

import ILocalStorageStore from '../Interfaces/ILocalStorageStore';

const subscribeToVolumeMutedWrite = (
    volumeMutedWriteStream$: Observable<boolean>,
    localStorageStore: ILocalStorageStore
): Subscription =>
    volumeMutedWriteStream$
        .subscribe(volumeMuted => {
            localStorageStore.actions.write({volumeMuted});
        });

export default subscribeToVolumeMutedWrite;